import styled from 'styled-components';

export const ReopenTicketForm = styled.form``;

export const LeaveModalConfimrationHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ReplyTextarea = styled.textarea`
  width: 100%;
  height: 85px;
  padding: 10px;
  box-sizing: border-box;
  resize: none;
  margin-bottom: 10px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 0.5px solid #222247;
  border-radius: 7px;
`;

export const LeaveRequestDetail = styled.form`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  width: 100%;
  gap: 5px;
  justify-content: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 30px;
  opacity: 1;
  padding: 20px;
  height: 95%;
`;

export const ReopenLabel = styled.div`
  font: normal 18px/28px Biotif;
  letter-spacing: 0px;
  color: #222247;
`;

export const ReopenFooter = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 8px;
  button : {
    border: 1px solid #4948ac;
    border-radius: 4px;
  }
`;

export const FormInputWrapper = styled.div`
  flex: 1 0 calc(33.33% - 10px);
  max-height: 75px;
  margin-right: 10px;

  p {
    margin: 2px;
  }

  input,
  select {
    border: 0.5px solid #222247;
    border-radius: 5px;
    opacity: 1;
    width: 100%;
    margin-top: 8px;
  }

  input:disabled {
    background: #f3f4f8;
    cursor: not-allowed;
  }

  select:disabled {
    background: #f3f4f8;
    cursor: not-allowed;
  }
`;

export const ActionCommomdropdown = styled.div`
  flex: 1 0 calc(33.33% - 10px);
  margin-right: 10px;
  select : {
    background-color: white !important;
    color: black !important;
  }
`;
